import React from "react";
import { Container } from "react-bootstrap";
import { Navbar, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ThemeToggle from "../common/ThemeToggle";
import Logo from "../common/Logo";

const Header = () => {
  const { isLoggedIn, logout, userRole } = useAuth();

  return (
    <Navbar
      style={{ backgroundColor: "#e3f2fd" }} // Same as footer background
      bg="light"
      data-bs-theme="light"
    >
      <Container className="justify-content-center">
        <Nav>
          {/* Use memoized Logo component */}
          <Navbar.Brand>
            <Logo />
          </Navbar.Brand>
        </Nav>
        <Nav className="ms-auto">
          {/* Theme Toggle */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginRight: '16px',
            padding: '4px 8px',
            borderRadius: '6px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)'
          }}>
            <ThemeToggle />
          </div>
          
          {isLoggedIn && userRole === "USER" && (
            <Link to="/home" className="nav-link">
              Home
            </Link>
          )}
          {isLoggedIn && userRole === "USER" && (
            <Link to="/ai" className="nav-link">
              AI
            </Link>
          )}
          {isLoggedIn ? (
            <Link to="/" className="btn btn-danger ms-3" onClick={logout}>
              Logout
            </Link>
          ) : (
            <>
              <Link 
                to="/login" 
                className="btn btn-primary me-2"
                style={{ 
                  backgroundColor: '#010000',
                  borderColor: '#010000',
                  color: 'white'
                }}
              >
                Login
              </Link>
              <Link to="/register" className="btn btn-secondary">
                Register
              </Link>
            </>
          )}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Header;
